<div class="declaration">
  <!-- Sin texto cargado no se puede marcar: la versión viaja con la aceptación -->
  <mat-checkbox color="primary" [checked]="checked" [disabled]="!version" (change)="onChange($event.checked)">
    <span class="declaration-text" *ngIf="version">
      <span class="declaration-paragraph" *ngFor="let paragraph of paragraphs">{{ paragraph.before }}<a *ngIf="paragraph.link" [href]="privacyUrl" target="_blank" rel="noopener">{{ paragraph.link }}</a>{{ paragraph.after }}</span>
    </span>
    <span class="declaration-text" *ngIf="!version && !loadError">Cargando la declaración…</span>
  </mat-checkbox>

  <p class="declaration-error" *ngIf="loadError">
    No se pudo cargar la declaración.
    <a href="javascript:void(0)" (click)="load()">Intentar de nuevo</a>
  </p>
</div>
